module.exports = __webpack_public_path__ + "media/images/guides/random-01-7f07f2a619804a608ecfe25aa1218e2e.svg";